import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h3>TM AppDefi</h3>
        <p>Powered By The Almighty Hijtyaq</p>
        <div className="social-links">
          <a href="#">Twitter</a>
          <a href="#">Telegram</a>
          <a href="#">Discord</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
